var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.667 33.333 87.5 12.5m0 0H66.667m20.833 0v20.833m-54.167 0L12.5 12.5m0 0v20.833m0-20.833h20.833m0 54.167L12.5 87.5m0 0h20.833m-20.833 0V66.667m54.167 0L87.5 87.5m0 0V66.667m0 20.833H66.667",
    stroke: "currentColor",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgExpand;